import * as React from 'react'
import { Select } from './Select'
import type { Country } from '@/shared/data/countries'
import { COUNTRIES, COUNTRY_BY_CODE } from '@/shared/data/countries'

type Props = {
  value: string // ISO2 code
  onChange: (code: string) => void
  includeDial?: boolean
  className?: string
}

export function CountrySelect({ value, onChange, includeDial = true, className }: Props) {
  // Garantir código válido
  const current = COUNTRY_BY_CODE.get(value) ? value : 'BR'
  return (
    <Select className={className} value={current} onChange={(e) => onChange((e.target as HTMLSelectElement).value)}>
      {COUNTRIES.map((c) => (
        <option key={c.code} value={c.code}>
          {c.flag} {c.name}{includeDial ? ` (+${c.dial})` : ''}
        </option>
      ))}
    </Select>
  )
}

